import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		margin: '0 auto',
		maxWidth: 600,
		paddingTop: spacing.xl,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: common.border,
	},
	tabViewItem: {
		color: colors.text.light,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: typography.fontSizes.sm,
		height: 44,
		paddingLeft: spacing.xl,
		paddingRight: spacing.xl,
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: spacing.sm,
	},
	tabItemSelected: {
		borderBottom: `1px solid ${colors.primary.main}`,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
		padding: spacing.md,
	},
	inputWrapper: {
		width: 300,
	},
	logo: {
		...CssSelectors.allChildren({
			display: 'block',
			width: 350,
		}),
	},
	signInFormField: {
		display: 'flex',
		margin: 0,
		width: 300,
	},
	textInput: {
		width: '100%',
	},
	signInFormFieldLabel: {
		color: colors.text.main,
		display: 'block',
		fontSize: typography.fontSizes.sm,
		lineHeight: 1.57,
	},
	signInFormFieldError: {
		color: colors.danger.dark,
		display: 'block',
		fontSize: typography.fontSizes.xs,
		lineHeight: 1.5,
		marginTop: spacing.xs,
	},
	signInContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
	},
	signInForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
});
